module.exports = __webpack_public_path__ + "img/dl-mac-ac.2d21fbfb.png";